import React, { useEffect, useState } from 'react';
import { Release } from 'types/releases';
import { useAppDispatch } from 'app/store';
import { deleteReleaseEffect } from 'app/store/Releases/effects';
import { GenericObject } from 'types/generic.types';
import { Text } from '@chakra-ui/react';
import { ChakraConfirmationDialog } from 'app/components/Dialogs';

interface DeleteReleaseDialogProps {
  release?: Release;
  onClose: () => void;
}

export const DeleteReleaseDialog: React.FC<DeleteReleaseDialogProps> = ({
  release,
  onClose,
}) => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [lastReleaseGuid, setLastReleaseGuid] = useState('');
  const [releasesTitle, setReleasesTitle] = useState<GenericObject<string>>({});

  const onConfirm = async () => {
    if (!release) {
      return;
    }
    try {
      setLoading(true);
      await dispatch(
        deleteReleaseEffect({ releaseGuid: release.guid })
      ).unwrap();
      onClose();
    } catch (e) {
      // proceed
    } finally {
      setLoading(false);
    }
  };

  // Prevent Release title disappearing from dialog content on dialog close transition animation
  useEffect(() => {
    if (release) {
      setLastReleaseGuid(release.guid);
      setReleasesTitle((prev) => ({ ...prev, [release.guid]: release.title }));
    }
  }, [release]);

  return (
    <ChakraConfirmationDialog
      title="Delete Release"
      actionButtonText="Delete"
      handleAction={onConfirm}
      isOpen={Boolean(release)}
      onClose={onClose}
      disableSubmitAction={loading}
    >
      <Text fontSize="md" data-testid="dialog-text" wordBreak="break-word">
        Are you sure you want to delete Release
        <i> {releasesTitle[release?.guid || lastReleaseGuid || '']} </i>?
      </Text>
    </ChakraConfirmationDialog>
  );
};
